import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

function EarningsTooltip({ model, price, date }) {
  const modelTitle = model.length > 25 ? `${model.substr(0, 25)}...` : model

  return (
    <div className="earnings-tooltip">
      <div className="tooltip-title">Last sale</div>
      <div className="tooltip-model">
        <div className="tooltip-model__title">
          {modelTitle} <span className="tooltip-model__price">{numeral(price).format('$0.00')}</span>
        </div>
      </div>
      <div className="tooltip-date">{date}</div>
    </div>
  )
}

EarningsTooltip.propTypes = {
  model: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  date: PropTypes.string.isRequired,
}

export default EarningsTooltip
